__turbopack_context__.v({
  "defaultHeader": "section-container-module-scss-module__exNY_q__defaultHeader",
  "defaultTitle": "section-container-module-scss-module__exNY_q__defaultTitle",
  "root": "section-container-module-scss-module__exNY_q__root",
});
